import { Media } from 'media'
import { ComponentType } from 'react'
import { RoleModel } from 'utils/role'
import { Footer } from './footer'
import { PropertyDesktop } from './property-desktop'
import { PropertyPrint } from './property-print'
import { PropertyMobile } from './property-mobile'
import { Related } from './related'
import { Schema } from './schema'
import { Seo } from './seo'

interface Props {
  property: any
  agent: any
  role: RoleModel
  category: any
  zone: any
  beforeOnShareClick: () => Promise<void>
  shareUrl: string
}

export const Property: ComponentType<Props> = ({ property, agent, role, category, zone, beforeOnShareClick, shareUrl }) => (
  <>
    <Seo property={property} />
    <Schema property={property} />
    <Media at="xs">
      <PropertyMobile {...{ property, agent, beforeOnShareClick, shareUrl }} />
    </Media>
    <Media greaterThan="xs">
      <PropertyDesktop {...{ property, agent, beforeOnShareClick, shareUrl }} />
    </Media>
    <span className="print--only">
      <PropertyPrint key="something" {...{ property, agent, beforeOnShareClick, shareUrl }} />
    </span>
    <span className="print--none">
      <Related {...{ role, category, zone, property }} />
    </span>
    <Footer />
  </>
)
